import { useState } from "react";
import { useDispatch } from "react-redux";
import JobCard from "../components/JobCard";
import { setJob } from "../store/postsSlice";
// ===================================================================
// 2. CREATE A DEDICATED JobCard COMPONENT FOR CLEANLINESS
// This component renders a single job with your desired detailed layout.
// ===================================================================


// ===================================================================
// MAIN JobList COMPONENT
// Now much cleaner, as it delegates rendering to JobCard
// ===================================================================
const JobList = ({ data, isLoading, page, onPageChange, recordsPerPage }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  if (isLoading) {
    return <div className="text-center p-10 font-semibold text-gray-600">Loading jobs...</div>;
  }

  const jobs = data?.jobs || [];
  const hasMore = data?.hasMore || false;
  const totalJobs = data?.totalJobs;

  if (jobs.length === 0) {
    return <div className="text-center p-10 bg-gray-100 rounded-md text-gray-700">No jobs found matching your criteria.</div>;
  }

  const handleJobClick = (job) => {
    dispatch(setJob(job));
    // Always show job details in the main right panel on larger screens.
    // Only open the modal on smaller screens where the right panel isn't visible.
    if (window.innerWidth <= 1024) { // Example breakpoint for modal
      setIsModalOpen(true);
    }
  };

  const startRecord = page * recordsPerPage + 1;
  const endRecord = startRecord + jobs.length - 1;

  const PaginationControls = () => (
    <div className="flex justify-between items-center my-4 px-1">
      <div className="text-sm text-gray-700">
        Showing <span className="font-medium">{startRecord}</span> to <span className="font-medium">{endRecord}</span>
        {totalJobs !== undefined ? (
          <span> of <span className="font-medium">{totalJobs}</span> results</span>
        ) : (
          hasMore && <span> of many</span>
        )}
      </div>
      <div className="flex gap-2">
        <button onClick={() => onPageChange(page - 1)} disabled={page === 0} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Previous
        </button>
        <button onClick={() => onPageChange(page + 1)} disabled={!hasMore} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Next
        </button>
      </div>
    </div>
  );

  return (
    <div className="w-full">
      <PaginationControls />

      {/* 3. CLEANED UP RENDER LOOP */}
      <div className="flex flex-col gap-4">
        {jobs.map((job) => (
          <div
            key={job.id} // Use the unique job ID for the key
            onClick={() => handleJobClick(job)} // Attach the click handler here
            className="rounded-lg shadow-md hover:shadow-xl transition-shadow duration-200 cursor-pointer overflow-hidden border border-gray-200"
          >
            <JobCard job={job} />
          </div>
        ))}
      </div>

      <div className="mt-6">
        <PaginationControls />
      </div>
    </div>
  );
};

export default JobList;